// frigade-provider-wrapper.tsx
"use client";
import { useAuth, useOrganization, useUser } from "@clerk/nextjs";
import * as Frigade from "@frigade/react";
import { ReactNode } from "react";
import { useRouter } from 'next/navigation'; // or 'next/router' if using Pages Router

// Replace this with your Frigade public API key
const FRIGADE_API_KEY =
  process.env.FRIGADE_PUBLIC_API_KEY ||
  "api_public_b8gr4NqMsOx4WGcZSRWDjcp9aS8SzVAj344hdEIO5xDAsblcGDSJPI4BV0WWZwFi";

interface FrigadeProviderWrapperProps {
  children: ReactNode;
}

export const FrigadeProviderWrapper: React.FC<FrigadeProviderWrapperProps> = ({
  children,
}) => {
  const { userId, orgId } = useAuth();
  const { user } = useUser();
  const { organization } = useOrganization();
  const router = useRouter();

  console.log("Frigade User", user, user?.primaryEmailAddress?.emailAddress, `${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim())
  return (
    <Frigade.Provider
      apiKey={FRIGADE_API_KEY}
      // Replace this with the ID of the signed in user
      navigate={(url, target) => {
        if (target === "_blank") {
          window.open(url, "_blank");
        } else {
          router.push(url);
        }
      }}
      userId={userId || ""}
      userProperties={{
        email: user?.primaryEmailAddress?.emailAddress || "",
        firstName: user?.firstName ?? "",
        lastName: user?.lastName ?? "",
      }}
      groupId={orgId || ""}
      groupProperties={{
        name: organization?.name || ""
      }}
      theme={{
        colors: {
          primary: {
            foreground: 'hsl(var(--primary-foreground))',
            background: 'hsl(var(--primary))',
            surface: 'hsl(var(--primary))',
            border: 'hsl(var(--primary))',
            hover: {
              background: 'hsl(var(--primary) / 0.9)',
              surface: 'hsl(var(--primary) / 0.9)',
              border: 'hsl(var(--primary) / 0.9)',
            },
          },
          secondary: {
            foreground: 'hsl(var(--secondary-foreground))',
            background: 'hsl(var(--secondary))',
            surface: 'hsl(var(--secondary))',
            border: 'hsl(var(--secondary))',
            hover: {
              background: 'hsl(var(--secondary) / 0.8)',
              surface: 'hsl(var(--secondary) / 0.8)',
              border: 'hsl(var(--secondary) / 0.8)',
            },
          },
          neutral: {
            background: 'hsl(var(--card))',
            foreground: 'hsl(var(--neutral-foreground))',
            border: 'hsl(var(--border))',
            '100': 'hsl(var(--neutral))',
            '200': 'hsl(var(--neutral))',
            '300': 'hsl(var(--neutral))',
            '400': 'hsl(var(--neutral))',
            '500': 'hsl(var(--accent))',
            '600': 'hsl(var(--accent))',
            '700': 'hsl(var(--accent))',
            '800': 'hsl(var(--accent))',
            '900': 'hsl(var(--accent))',
          },
        },
      }}    
    >
      {children}
    </Frigade.Provider>
  );
};
